<template functional>
  <form
    class="relative w-full tint-less tint:focus-within:hover"
    :class="['o-clean-form', props.formClasses]"
    :style="props.formStyle"
    @submit.prevent="listeners.submit"
  >
    <input
      class="block p-2 w-full sm:font-light"
      :class="props.fieldClasses || ``"
      v-bind="data.attrs"
      name="field"
    />
    <button
      :data-test="props.buttonTest"
      :class="['button-reset o-button', props.buttonClasses]"
      :title="props.buttonTitle"
      :style="props.buttonStyles"
      type="submit"
    >
      +
    </button>
  </form>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>
